var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.828 8.3831C13.8363 8.37587 13.8444 8.36832 13.8522 8.36045C13.8941 8.31861 13.9269 8.2712 13.9508 8.22061C14.0403 8.03457 14.0078 7.80465 13.8536 7.65043C13.8404 7.63717 13.8265 7.6248 13.8122 7.61335L9.96314 3.76425C9.76788 3.56899 9.45129 3.56899 9.25603 3.76425C9.06077 3.95952 9.06077 4.2761 9.25603 4.47136L12.2954 7.51069L2.59535 7.51069C2.31921 7.51069 2.09535 7.73455 2.09535 8.01069C2.09535 8.28683 2.31921 8.51069 2.59535 8.51069L12.2862 8.51069L9.25742 11.5395C9.06216 11.7348 9.06216 12.0514 9.25742 12.2466C9.45268 12.4419 9.76926 12.4419 9.96453 12.2466L13.828 8.3831Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowRight);
export default __webpack_public_path__ + "static/media/ic_arrow_right.bca2fe3c2c1a03d1a4cff648894aedbb.svg";
export { ForwardRef as ReactComponent };